import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="footer d-flex flex-row">
        <span>Credits: <a href="https://github.com/srividyabv1996" target="_blank">Srividya B V</a></span>
        <span>© 2023 Copyright: <a href="/">P. N. Karthik</a></span>
      </div>
    </footer>
  );
}

export default Footer;